"use strict";
exports.__esModule = true;
exports.ShopConnectionBuilder = exports.MerchantShopResetStateOperationStateBuilder = exports.MerchantCatalogSyncPlatformToShopOperationStateBuilder = exports.OrdersSyncPlatformToShopOperationStateBuilder = exports.OrdersSyncShopToPlatformOperationStateBuilder = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var OrdersSyncShopToPlatformOperationStateBuilder = /** @class */ (function () {
    function OrdersSyncShopToPlatformOperationStateBuilder(state) {
        this.state = state;
    }
    OrdersSyncShopToPlatformOperationStateBuilder.initialise = function (enabled, recurrent, batchSize) {
        if (enabled === void 0) { enabled = true; }
        if (recurrent === void 0) { recurrent = true; }
        if (batchSize === void 0) { batchSize = 5; }
        return new OrdersSyncShopToPlatformOperationStateBuilder({
            enabled: enabled,
            recurrent: recurrent,
            batchSize: batchSize,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    OrdersSyncShopToPlatformOperationStateBuilder.initialiseWithState = function (state) {
        return new OrdersSyncShopToPlatformOperationStateBuilder(state);
    };
    OrdersSyncShopToPlatformOperationStateBuilder.prototype.withLastExecuted = function (lastExecuted) {
        this.state.lastExecuted = lastExecuted;
        this.state.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    OrdersSyncShopToPlatformOperationStateBuilder.prototype.build = function () {
        return this.state;
    };
    return OrdersSyncShopToPlatformOperationStateBuilder;
}());
exports.OrdersSyncShopToPlatformOperationStateBuilder = OrdersSyncShopToPlatformOperationStateBuilder;
var OrdersSyncPlatformToShopOperationStateBuilder = /** @class */ (function () {
    function OrdersSyncPlatformToShopOperationStateBuilder(state) {
        this.state = state;
    }
    OrdersSyncPlatformToShopOperationStateBuilder.initialise = function (enabled) {
        if (enabled === void 0) { enabled = true; }
        return new OrdersSyncPlatformToShopOperationStateBuilder({
            enabled: enabled,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    OrdersSyncPlatformToShopOperationStateBuilder.initialiseWithState = function (state) {
        return new OrdersSyncPlatformToShopOperationStateBuilder(state);
    };
    OrdersSyncPlatformToShopOperationStateBuilder.prototype.withLastExecuted = function (lastExecuted) {
        this.state.lastExecuted = lastExecuted;
        this.state.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    OrdersSyncPlatformToShopOperationStateBuilder.prototype.build = function () {
        return this.state;
    };
    return OrdersSyncPlatformToShopOperationStateBuilder;
}());
exports.OrdersSyncPlatformToShopOperationStateBuilder = OrdersSyncPlatformToShopOperationStateBuilder;
var MerchantCatalogSyncPlatformToShopOperationStateBuilder = /** @class */ (function () {
    function MerchantCatalogSyncPlatformToShopOperationStateBuilder(state) {
        this.state = state;
    }
    MerchantCatalogSyncPlatformToShopOperationStateBuilder.initialise = function (enabled) {
        if (enabled === void 0) { enabled = true; }
        return new MerchantCatalogSyncPlatformToShopOperationStateBuilder({
            enabled: enabled,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    MerchantCatalogSyncPlatformToShopOperationStateBuilder.initialiseWithState = function (state) {
        return new MerchantCatalogSyncPlatformToShopOperationStateBuilder(state);
    };
    MerchantCatalogSyncPlatformToShopOperationStateBuilder.prototype.withLastExecuted = function (merchantChannelCatalogId, lastExecuted) {
        this.state.merchantChannelCatalogId = merchantChannelCatalogId;
        this.state.lastExecuted = lastExecuted;
        this.state.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    MerchantCatalogSyncPlatformToShopOperationStateBuilder.prototype.build = function () {
        return this.state;
    };
    return MerchantCatalogSyncPlatformToShopOperationStateBuilder;
}());
exports.MerchantCatalogSyncPlatformToShopOperationStateBuilder = MerchantCatalogSyncPlatformToShopOperationStateBuilder;
var MerchantShopResetStateOperationStateBuilder = /** @class */ (function () {
    function MerchantShopResetStateOperationStateBuilder(state) {
        this.state = state;
    }
    MerchantShopResetStateOperationStateBuilder.initialise = function (enabled) {
        if (enabled === void 0) { enabled = true; }
        return new MerchantShopResetStateOperationStateBuilder({
            enabled: enabled,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    MerchantShopResetStateOperationStateBuilder.initialiseWithState = function (state) {
        return new MerchantShopResetStateOperationStateBuilder(state);
    };
    MerchantShopResetStateOperationStateBuilder.prototype.withLastExecuted = function (lastExecuted) {
        this.state.lastExecuted = lastExecuted;
        this.state.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    MerchantShopResetStateOperationStateBuilder.prototype.build = function () {
        return this.state;
    };
    return MerchantShopResetStateOperationStateBuilder;
}());
exports.MerchantShopResetStateOperationStateBuilder = MerchantShopResetStateOperationStateBuilder;
var ShopConnectionBuilder = /** @class */ (function () {
    function ShopConnectionBuilder(shopConnection) {
        this.shopConnection = shopConnection;
    }
    ShopConnectionBuilder.initialise = function (merchantChannelId, shopName, primaryDomain, accessToken, operationState) {
        return new ShopConnectionBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            merchantChannelId: merchantChannelId,
            shopName: shopName,
            primaryDomain: primaryDomain,
            accessToken: accessToken,
            operationState: operationState,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    ShopConnectionBuilder.prototype.getId = function () {
        return this.shopConnection.id;
    };
    ShopConnectionBuilder.prototype.build = function () {
        return this.shopConnection;
    };
    ShopConnectionBuilder.prototype.buildUpdate = function () {
        return {
            merchantChannelId: this.shopConnection.merchantChannelId,
            shopName: this.shopConnection.shopName,
            primaryDomain: this.shopConnection.primaryDomain,
            accessToken: this.shopConnection.accessToken,
            operationState: this.shopConnection.operationState
        };
    };
    return ShopConnectionBuilder;
}());
exports.ShopConnectionBuilder = ShopConnectionBuilder;
